/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PaymentStatus = {
    Initiated: 'Initiated',
    Pending: 'Pending',
    Paid: 'Paid',
    Failed: 'Failed',
    Refunded: 'Refunded',
    Cancelled: 'Cancelled',
    Expired: 'Expired'
} as const;
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];

